module.exports = __webpack_public_path__ + "static/media/projects_thumb_rush_bookmarks_2x.373e3625.jpg";